import {Component, Input, HostListener} from "@angular/core";
import {Business} from "../../model/business";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";

declare const $:any;

@Component({
  selector: 'top-business',
  template: require('./top-business.component.html'),
  styles: [
    require('./top-business.component.scss')
  ]
})

export class TopBusinessComponent {

  business:Business;

  profileHeight:number;

  topMinified:boolean = false;
  topMinimum:boolean = false;

  constructor(private currentBusiness: CurrentBusinessService) {
    this.business = this.currentBusiness.currentBusiness;
    this.bindPageScroll();

    let that = this;

    window.addEventListener( "scroll", function( event ) {
      that.handleTopSize();

      setTimeout(function () {
        that.handleTopSize();
      }, 250);
    });
  }

  // @HostListener('window:scroll', ['$event'])
  handleTopSize() {
    if($(window).width() > 760) {
      let scroll = $(window).scrollTop();
      let $topProfile = $('.top-business');

      this.profileHeight = $(window).height() / 2;

      let size = this.profileHeight - scroll;

      if (size > 150) {
        $topProfile.height(this.profileHeight - scroll);
        this.topMinimum = false;
      } else {
        this.topMinimum = true;
      }

      if (size < (this.profileHeight / 3 * 2)) {
        this.topMinified = true;
      } else {
        this.topMinified = false;
      }
    } else {
      this.topMinified = true;
    }
  }

  bindPageScroll() {
    let that = this;

    that.handleTopSize();

    $(window).scroll(function (event) {
      that.handleTopSize();
    });

    $(window).resize(function () {
      that.handleTopSize();
    })
  }

}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/top-business/top-business.component.ts